import { isCommercialSuretyBondType } from "@inrev/common";
import type { UseFormClearErrors, UseFormSetValue } from "react-hook-form";
import { EMPTY_BOND_FORM } from "../../../constants";
import type { SubmissionFormData } from "./bondRequestSubmissionFormSchema";

const cleared = { shouldValidate: false } as const;

const clearBidBondFields = (setValue: UseFormSetValue<SubmissionFormData>) => {
	setValue("bidBondId", undefined, cleared);
	setValue("actualBidAmount", undefined, cleared);
	setValue("actualBidDate", undefined, cleared);
};

const clearLaterStepFields = (setValue: UseFormSetValue<SubmissionFormData>) => {
	setValue("projectName", "", cleared);
	setValue("bidAmount", undefined, cleared);
	setValue("submissionNarrative", "", cleared);
	setValue("scopeOfWork", [], cleared);
	setValue("completionBond", undefined, cleared);
	setValue("tListingRequired", undefined, cleared);
	setValue("bidDate", undefined, cleared);
	setValue("finalBondFormType", undefined, cleared);
	setValue("secondBid", undefined, cleared);
	setValue("bondAmount", undefined, cleared);
	setValue("contractAmount", undefined, cleared);
	setValue("contractAmountEdited", undefined, cleared);
	setValue("effectiveDate", undefined, cleared);
	setValue("bondForm", EMPTY_BOND_FORM, cleared);
};

const bidBondFields = ["bidBondId", "actualBidAmount", "actualBidDate"] as const;
const laterStepFields = [
	"projectName",
	"bidAmount",
	"submissionNarrative",
	"scopeOfWork",
	"completionBond",
	"tListingRequired",
	"bidDate",
	"finalBondFormType",
	"secondBid",
	"bondAmount",
	"contractAmount",
	"contractAmountEdited",
	"effectiveDate",
	"bondForm",
] as const;

export const clearFieldsAfterPrincipal = (
	setValue: UseFormSetValue<SubmissionFormData>,
	clearErrors: UseFormClearErrors<SubmissionFormData>,
) => {
	clearBidBondFields(setValue);
	clearLaterStepFields(setValue);
	clearErrors([...bidBondFields, ...laterStepFields]);
};

export const clearFieldsAfterBondType = (
	setValue: UseFormSetValue<SubmissionFormData>,
	clearErrors: UseFormClearErrors<SubmissionFormData>,
	bondType: SubmissionFormData["bondType"],
) => {
	if (isCommercialSuretyBondType(bondType)) {
		setValue("contractBondType", undefined, cleared);
	}
	clearBidBondFields(setValue);
	clearLaterStepFields(setValue);
	clearErrors(["contractBondType", ...bidBondFields, ...laterStepFields]);
};

export const clearFieldsAfterAccount = (
	setValue: UseFormSetValue<SubmissionFormData>,
	clearErrors: UseFormClearErrors<SubmissionFormData>,
) => {
	setValue("principal", undefined, cleared);
	setValue("bondType", undefined, cleared);
	setValue("contractBondType", undefined, cleared);
	clearBidBondFields(setValue);
	clearLaterStepFields(setValue);
	clearErrors(["principal", "bondType", "contractBondType", ...bidBondFields, ...laterStepFields]);
};
